/**
 * Helper to get localized text for dynamic content like menu items or categories
 * @param {Object} item - The data object (menu item, category, etc.)
 * @param {string} field - The field name (e.g., 'name', 'description')
 * @param {string} language - Current language code (e.g., 'en', 'hi', 'te')
 * @param {string} fallbackField - Optional field to fallback to if translation missing
 * @returns {string} - The localized text or fallback
 */
export const getLocalizedText = (item, field, language, fallbackField = 'name') => {
    if (!item) return '';
    
    // If language is English, return the primary field
    if (language === 'en' || !language) {
        return item[field] || item[fallbackField] || '';
    }

    // Check for localized field (e.g., name_hi, description_te)
    const localizedKey = `${field}_${language}`;
    
    if (item[localizedKey] && item[localizedKey].trim() !== '') {
        return item[localizedKey];
    }

    // Fallback if the specific field translation is missing
    // 1. Try English version of the SAME field
    if (item[field] && item[field].trim() !== '') {
        return item[field];
    }

    // 2. Final fallback to the primary name/identity
    return item[fallbackField] || '';
};
